
import { prefix } from "../helpers";

/**
 * ReferralData (PILLARS-3269): elenco pubblico dei referral con il logo da usare
 * per brandizzare la registrazione. Non richiede utente loggato: l'unico header
 * necessario è X-Application, già impostato globalmente in main.js.
 */
const namespace = "referraldata";

const nameSpace = {
  get: {
    // Ritorna l'intera lista [{ id, referralCode, subscriptionLogo }]:
    // il backend non espone una get per singolo codice, il match è lato client.
    getList: () => [`${prefix}/profile/${namespace}`],
  },
};

export default nameSpace;
